import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { EQUIPMENT_CACHE_KEY } from 'services/queryKeys';
import { Equipment } from './types';

export const useGetAvailableEquipment = () => {
  const { data: equipment = [], isLoading } = useAxiosQuery<Equipment[]>(
    EQUIPMENT_CACHE_KEY(),
    `/organisations/equipments/`
  );

  return {
    equipment,
    isLoading,
  };
};
